<template>
  <o-table
    :items="spotTrackers"
    :loading="loading"
    defaultSort="number"
    :draggable="false"
    paginated
    :per-page="100"
  >
    <b-table-column v-slot="{ index }" cell-class="has-text-grey">
      {{ index + 1 }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="number" label="Numéro" sortable>
      <b-tooltip type="is-light" position="is-right" multilined>
        <template #content>
          <div>ESN : {{ row.serialNumber }}</div>
          <div>Auth : {{ row.authorizationCode }}</div>
        </template>
        <span class="has-text-weight-medium">{{ row.number }}</span>
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="expiredAt" label="Date d'expiration" sortable>
      <span :class="isPast(row.expiredAt) ? 'has-text-danger has-text-weight-medium' : ''">
        {{ formatDate(row.expiredAt) }}
      </span>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="availability" label="Status" sortable>
      <b-tag :type="tags[row.availability].type">
        {{ tags[row.availability].label }}
      </b-tag>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="wear" label="Usure" sortable>
      <b-tooltip
        :label="wears.find((wear) => wear.value === row.wear).label"
        type="is-light"
        position="is-right"
      >
        <b-icon :icon="wearIcons[row.wear].icon" size="is-small" :type="wearIcons[row.wear].type" />
      </b-tooltip>
    </b-table-column>
    <b-table-column v-slot="{ row }" field="model" label="Modèle" sortable>
      {{ spotModels[row.model] }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="owner" label="Propriétaire" sortable>
      {{ capitalize(row.owner) }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="firmwareVersion" label="Version" sortable>
      {{ row.firmwareVersion || '–' }}
    </b-table-column>

    <b-table-column v-slot="{ row }" field="locatedAt" label="Dernier point" sortable>
      {{ formatDate(row.locatedAt) }}
    </b-table-column>
    <b-table-column v-slot="{ row }" field="batteryPercentage" label="Batterie" sortable>
      <o-battery-level-indicator
        v-if="row.batteryPercentage"
        :battery-percentage="row.batteryPercentage"
      />
      <span v-else>–</span>
    </b-table-column>

    <b-table-column v-slot="{ row }" label="">
      <div class="buttons are-small is-right">
        <b-button
          type="is-primary"
          tag="router-link"
          :to="{ name: 'spotTracker.edit', params: { id: row.id } }"
        >
          <b-icon icon="edit" />
        </b-button>
      </div>
    </b-table-column>
  </o-table>
</template>

<script>
import { format, isPast } from 'date-fns'
import { capitalize } from '@helpers/capitalize'
import { TAGS } from '@constants/tracker/tag'
import { SPOT_MODELS } from '@constants/tracker/model'
import { WEARS, WEAR_ICONS } from '@constants/tracker/wear'
import OTable from '@components/Table.vue'
import OBatteryLevelIndicator from '@components/BatteryLevelIndicator.vue'

export default {
  name: 'ListSpotTrackersTable',

  components: {
    OBatteryLevelIndicator,
    OTable,
  },

  props: {
    spotTrackers: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      default: null,
    },
  },

  created() {
    this.tags = TAGS
    this.spotModels = SPOT_MODELS
    this.wears = WEARS
    this.wearIcons = WEAR_ICONS
  },

  methods: {
    formatDate(date) {
      return !date ? 'Aucune date' : format(date, 'dd/MM/yyyy')
    },

    capitalize(value) {
      return capitalize(value)
    },

    isPast(date) {
      return isPast(date)
    },
  },
}
</script>
